export enum Field {
  Firstname = 'firstname',
  Lastname = 'lastname',
  Phone = 'phone',
  ClinicId = 'clinicId',
  DoctorId = 'doctorId',
  IsSuccess = 'isSuccess',
  Text = 'text',
}

export type Value = string | number | boolean;

export const DEFAULT_FEEDBACK: Record<string, Value> = {
  [Field.Firstname]: '',
  [Field.Lastname]: '',
  [Field.Phone]: '',
  [Field.ClinicId]: 0,
  [Field.DoctorId]: 0,
  [Field.IsSuccess]: true,
  [Field.Text]: '',
};

export type Feedback = typeof DEFAULT_FEEDBACK;
